// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

const routes = [{
    path: '/admin/setup/progress',
    componentPath: 'views/admin/setup/progress',
}, {
    path: '/admin/about',
    componentPath: 'views/admin/about/index',
}, {
    path: '/admin/server/tools',
    componentPath: 'views/admin/server/tools',
}, {
    path: '/smb/file-manager/show',
    componentPath: 'views/smb/file-manager',
}, {
    path: '/smb/file-manager/edit',
    componentPath: 'views/smb/file-manager',
}, {
    path: '/smb/file-manager/code-editor',
    componentPath: 'views/smb/file-manager',
}, {
    path: '/smb/web/setup',
    componentPath: 'views/smb/web/setup',
}];

export default routes;



// WEBPACK FOOTER //
// ./plesk/routes.js